// This file can be replaced during build by using the `fileReplacements` array.
// `ng build ---prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  settings: {
    baseWebUrl: 'https://test.rentascordoba.gob.ar/',
    Decidir2ApiUrl: 'http://10.42.38.98:8082/WSRestDecidir/',
    urlPageRentas: 'https://preprod.rentascordoba.gob.ar/mirentas/rentas.html',
    urlApp: 'apppreprod',
    DecidirPublicKey: 'qRKeUeQi5lbdbvyx6xwWHmisn7GlQpnl',
    UrlDecidir: 'https://developers.decidir.com/api/v2',
    urlPayway: "https://developers-ventasonline.payway.com.ar/api/v2",
    environment: '',
    main_cookie: 'RENTASPREPROD',
    url_perfil: 'https://preprod.rentascordoba.gob.ar/nuevorentas/',
    url_representados: 'https://preprod.rentascordoba.gob.ar/nuevorentas/mis-representados',
    url_adhesiones: 'https://preprod.rentascordoba.gob.ar/nuevorentas/mis-adhesiones',
    inicio_session: 'https://apppreprod.rentascordoba.gob.ar/rentas/servlet/ainiciarsesion',
    url_procurador: 'https://preprod.rentascordoba.gob.ar/mirentas/rentas.html?page=procurador_martillero',
    url_corredor: 'https://preprod.rentascordoba.gob.ar/mirentas/rentas.html?page=tramite_corredores',
    url_home: 'https://preprod.rentascordoba.gob.ar/mirentas/rentas.html',
    url_apprentas: 'https://apppreprod.rentascordoba.gob.ar',
    url_rentas: 'https://preprod.rentascordoba.gob.ar',
    authCaptcha: 'https://apppreprod.rentascordoba.gob.ar/WSRestDeudaR2/loginservice/anonymous/',
    navBarOptions: {
      linkLogoRentas: '',
      loginStatusOptions: {
        linkMiPerfil: '',
        linkCorredor: '',
        linkMartillero: '',
        linkProcurador: '',
        linkMisRepresentados: '',
        linkFiscalizaciones: '',
        linkLogOut: '',
        linkCidiLogin: '',
        linkCidiSignIn: '',
        linkAfipLogin: '',
        linkAfipSingIn: '',
        linkMiInicio: '',
        webPersonalizada: {
          linkGoToPerfil: '',
          linkEditPerfil: ''
        }
      }
    },
    webSubDomain: 'preprod',
    servicesSubdomain: "apppreprod",
    cookieName: 'RENTASPREPROD',
    surveyId: 'SHVu7OP8RE-WavR6DxJagUn1q1c0kSZLpCrOZZhB1DhUMkFJOUtHNjFVOFVETEcyWkdZQjRJRVExRy4u'
  }
};


/*
 * In development mode, to ignore zone related error stack frames such as
 * `zone.run`, `zoneDelegate.invokeTask` for easier debugging, you can
 * import the following file, but please comment it out in production mode
 * because it will have performance impact when throw error
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
